import SEOHead from '../../components/feature/SEOHead';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import DigitalBiologySection from './components/DigitalBiologySection';
import DigitalTransformationSection from './components/DigitalTransformationSection';
import DigitalWellnessSection from './components/DigitalWellnessSection';
import CTASection from './components/CTASection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import TeamSection from './components/TeamSection';
import MissionSection from './components/MissionSection';
import VisionSection from './components/VisionSection';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen" style={{ background: '#09090f' }}>
      <SEOHead />
      <Navbar />
      <HeroSection />
      <ServicesSection />
      <DigitalBiologySection />
      <DigitalTransformationSection />
      <DigitalWellnessSection />
      <CTASection />
      <ContactSection />
      <AboutSection />
      <TeamSection />
      <MissionSection />
      <VisionSection />
      <Footer />
    </div>
  );
}
